import * as Sentry from '@sentry/react';

const isDev = import.meta.env.DEV;

export const logger = {
  debug: (...args: unknown[]) => isDev && console.debug('[DEBUG]', ...args),
  info: (...args: unknown[]) => isDev && console.info('[INFO]', ...args),
  warn: (...args: unknown[]) => console.warn('[WARN]', ...args),
  error: (...args: unknown[]) => {
    console.error('[ERROR]', ...args);
    if (args[0] instanceof Error) {
      Sentry.captureException(args[0]);
    } else if (args.length > 0) {
      Sentry.captureMessage(args.map(arg => String(arg)).join(' '));
    }
  }
};
